import React, { useState, useEffect, Fragment } from 'react'

import { FaMoneyBillWave } from 'react-icons/fa'
import { TfiLayoutListThumb } from 'react-icons/tfi'
import { BiTransferAlt } from 'react-icons/bi'

import Transfer from './Transfer'
import Bills from './Bills'
import History from './History'
import Request from './Request'

import processingGIF from '../../Contents/images/utils/progress.gif'
import { useStateValue } from '../../Utils/StateProvider'
import { RiFileList3Line } from 'react-icons/ri'

const Payments = ({ screen, beneficiary }) => {
    const [{ processingDash }] = useStateValue()
    const [activeScreen, setActiveScreen] = useState('transfer')
    const [activeContent, setActiveContent] = useState()

    useEffect(() => {
        if (screen) setActiveScreen(screen)
    }, [])

    useEffect(() => {
        switch(activeScreen) {
            case 'bills':
                setActiveContent(<Bills />)
                break;
            case 'history':
                setActiveContent(<History />)
                break;
            case 'request':
                setActiveContent(<Request />)
                break;

            default:
                setActiveContent(<Transfer beneficiary={beneficiary} />)
        }
    }, [activeScreen])
    return (
        <Fragment>
            {
                processingDash && (
                    <div className="content process">
                        <img src={processingGIF} alt="processing..." />
                    </div>
                )
            }
            <div className='content payments'>
                <div className="row">
                    <div className="actions-bar">
                        <div 
                            className={activeScreen === "transfer" ? "action active" : "action"}
                            onClick={() => setActiveScreen('transfer')}
                        >
                            <span>Transfer</span> <BiTransferAlt />
                        </div>
                        <div 
                            className={activeScreen === "history" ? "action active" : "action"}
                            onClick={() => setActiveScreen('history')}
                        >
                            <span>History</span> <TfiLayoutListThumb />
                        </div>
                        <div 
                            className={activeScreen === "bills" ? "action active" : "action"}
                            onClick={() => setActiveScreen('bills')}
                        >
                            <span>Pay Bills</span> <FaMoneyBillWave />
                        </div>
                        <div 
                            className={activeScreen === "request" ? "action active" : "action"}
                            onClick={() => setActiveScreen('request')}
                        >
                            <span>Requests</span> <RiFileList3Line />
                        </div>
                    </div>
                    {activeContent}
                </div>
            </div>
        </Fragment>
    )
}

export default Payments
